import React, { useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import Footer from "../../components/Footer/Footer";
import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import AppDevelopment from "../../../src/Assets/Images/WebDevelopment/5016 1.webp";
import { experimentalStyled as styled } from "@mui/material/styles";
import ReactPlayer from "react-player";
import servicelogo1 from "../../../src/Assets/Images/Servicesinnerpageicons/AppDev/image 49.webp";
import servicelogo2 from "../../../src/Assets/Images/Servicesinnerpageicons/AppDev/image 50.webp";
import servicelogo3 from "../../../src/Assets/Images/Servicesinnerpageicons/AppDev/image 51.webp";
import servicelogo4 from "../../../src/Assets/Images/Servicesinnerpageicons/AppDev/image 52.webp";
import servicelogo5 from "../../../src/Assets/Images/Servicesinnerpageicons/AppDev/image 53.webp";

import Linkedinimg from "../../../src/Assets/Images/Servicesinnerpageicons/linkedinmarketing.png";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";

const content = [
  "Profile Audit & Optimization",
  "Target Audience Research",
  "Content Strategy Creation",
  "Network Expansion",
  "Engagement Campaign Launch",
  "Lead Generation & Nurturing",
  "Performance Analysis & Refinement",
];

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

function Linkedinmarketinginner() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top when the component mounts
  }, []);

  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>Professional LinkedIn Marketing Services | B2B Lead Generation - Dwebbox</title>
        <meta
          name="description"
          content="Establish a powerful B2B brand presence on LinkedIn with Dwebbox. We specialize in profile optimization, audience targeting, content creation, and lead generation."
        />
        <meta name="keywords" content="LinkedIn marketing, B2B lead generation, profile optimization, content strategy, B2B networking, Dwebbox" />
        <link rel="canonical" href="https://dwebbox.com/linkedinmarketing" />
      </Helmet>
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <div>
        <Box sx={{ width: "100%", background: "#181818" }}>
          <Container
            component="main"
            sx={{ pt: 8, pb: 8, background: "#181818" }}
          >
            <Typography
              paragraph
              sx={{
                color: "#ffffff",
                fontSize: "20px",
                fontFamily: "DM Sans_18pt-ExtraLight",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "18px",
                },
              }}
            >
              <span
                style={{
                  content: "''",
                  display: "inline-block",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  background: "white",
                  marginRight: "5px",
                }}
              ></span>{" "}
              Our Services {/* Add a span with the bullet class */}
            </Typography>
            <Typography
              variant="h1"
              sx={{
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                fontSize: "70px",
                fontFamily: "Epilogue",
                fontWeight: "600",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "24px",
                },
              }}
            >
              Linkedin Marketing
            </Typography>
            <Typography
              variant="h2"
              sx={{
                color: "#ffffff",
                marginTop: "10vh",
                display: "flex",
                alignItems: "center",
                fontSize: "48px",
                fontFamily: "Epilogue",
                fontWeight: "600",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "24px",
                },
              }}
            >
              Building professional networks, one connection at a time, amplify
              your business presence
            </Typography>
            <Typography
              paragraph
              sx={{
                color: "#ffffff",
                fontSize: "24px",
                marginTop: "5vh",
                fontWeight: "250",
                fontFamily: "DM Sans_18pt-ExtraLight",
                width: "95%",
              }}
            >
              Developing powerful LinkedIn presence that generates real business
              results, a strategy that goes beyond social media.{" "}
            </Typography>
            <Typography
              paragraph
              sx={{
                color: "#ffffff",
                fontSize: "24px",
                marginTop: "5vh",
                fontWeight: "250",
                fontFamily: "DM Sans_18pt-ExtraLight",
                width: "95%",
              }}
            >
              LinkedIn marketing strategies and campaigns that your target
              audience will never forget. Create your professional brand from
              scratch or revamp your existing LinkedIn presence with the most
              strategic minds at your disposal. Discover the best of what B2B
              networking offers. Developing powerful LinkedIn presence that
              generates real business results, a strategy that goes beyond
              social media.{" "}
            </Typography>
            <Typography
              variant="h3"
              sx={{
                color: "#ffffff",
                marginTop: "10vh",
                display: "flex",
                alignItems: "center",
                fontSize: "32px",
                fontFamily: "Epilogue",
                fontWeight: "600",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "24px",
                },
              }}
            >
              Here is the proven process we follow to create the ideal LinkedIn
              strategy for you to connect with your customers professionally:
            </Typography>
          </Container>

          <Container
            component="main"
            sx={{
              pt: 3,
              pb: 5,
              background: "#181818",
              display: "flex",
              justifyContent: "space-between",
              height: "80vh",
              "@media (max-width:600px)": {
                // Styles for screens with a maximum width of 600px (mobile view)
                flexDirection: "column",
                height: "130vh",
              },
            }}
          >
            <Box
              sx={{
                background: "#000",
                width: "40%",
                height: "90%",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  width: "90%",
                  marginBottom: "5vh",
                  height: "40%",
                },
              }}
            >
              <img
                src={Linkedinimg}
                style={{
                  width: "100%",
                  height: "100%",
                  background: "black",
                  objectFit: "contain",
                }}
                alt=""
              />
            </Box>

            <Box
              sx={{
                width: "55%",
                height: "90%",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  width: "90%",
                },
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 0 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  className="inner-page-itemgrid"
                >
                  {[
                    servicelogo1,
                    servicelogo2,
                    servicelogo3,
                    servicelogo4,
                    servicelogo5,
                    servicelogo1,
                    servicelogo2,
                  ].map((serviceLogo, index) => (
                    <Grid item xs={2} sm={4} md={4} key={index}>
                      <Item
                        sx={{
                          borderRadius: "0",
                          border: "1px solid rgba(255, 255, 255, 0.2)",
                          background: "#181818",
                          height: "24vh",
                          "@media (max-width:600px)": {
                            // Styles for screens with a maximum width of 600px (mobile view)
                            height: "22vh",
                            width: "111%",
                            textAlign: "center",
                          },
                        }}
                      >
                        <img
                          src={serviceLogo}
                          alt={`Service Logo ${index + 1}`}
                          style={{ maxWidth: "67px", maxHeight: "67px" }}
                        />
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#ffffff",
                            fontSize: "16px",
                            fontWeight: "600",
                            fontFamily: "Epilogue",
                            "@media (max-width:600px)": {
                              // Styles for screens with a maximum width of 600px (mobile view)
                              fontSize: "12px",
                              fontWeight: "500",
                              marginTop: "1vh",
                              textAlign: "center",
                            },
                          }}
                        >
                          {content[index]}
                        </Typography>
                      </Item>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          </Container>
        </Box>
      </div>

      <Bgimage />
      <Footer />
    </div>
  );
}

export default Linkedinmarketinginner;
